/**
 * 現在の月に基づいてデフォルトの季節モードを返す。
 * 3月(index=2)〜11月(index=10) は夏期、それ以外は冬期。
 */
const SUMMER_START_MONTH = 2; // 3月 (0-indexed)
const SUMMER_END_MONTH = 10;  // 11月 (0-indexed)

export function getDefaultSeasonMode(): 'summer' | 'winter' {
  const month = new Date().getMonth();
  if (month >= SUMMER_START_MONTH && month <= SUMMER_END_MONTH) {
    return 'summer';
  }
  return 'winter';
}
